export { default } from "./src/bleeding-image-hero";

export type { UniformBleedingImageHeroProps } from "./src/bleeding-image-hero";
